export const NOTIFICATIONS_PAGE_URL = '/accounts/notifications/'; // acct_notifications

export const PUSH_API_URL = '/api/v1/push/'; // api:push-list
